module.exports = __webpack_public_path__ + "static/img/button-start-active-2.d9e8902.png";